// extracted by mini-css-extract-plugin
export default {"backgroundImage":"Canvas_backgroundImage__aQnGf","nonVisible":"Canvas_nonVisible__-sZjZ","mainCanvas":"Canvas_mainCanvas__c2Vlz","maskCanvas":"Canvas_maskCanvas__gG-Zs"};